import { z } from 'zod'

export const GroupSchema = () => {
  return z.object({
    group: z.object({
      id: z.string().nullish(),
    }),
  })
}
